import fetch from '@/plugins/fetch'
import utils from '@/plugins/utils'
import queryString from 'query-string'
import { PREFIX_BIGYUER_API } from '@/service'

const api = {
  businessList: PREFIX_BIGYUER_API + 'getYuerBusinessByCitycode',
  businessName: PREFIX_BIGYUER_API + 'isExistByBusinessName'
}
export default {
  async getBusinessListByCity({ commit }, { gbCode }) {
    const query = queryString.stringify({ gbCode })
    const res = await fetch(`${api.businessList}?${query}`)
    const json = await res.json()
    return json.content && json.content.list
  },
  async getBusinessByName({ commit }, { businessName }) {
    const query = queryString.stringify({ businessName })
    const res = await fetch(`${api.businessName}?${query}`)
    const json = await res.json()
    return json.content && json.content
  }
}
